import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { countriesApiSchema } from '../../models';

const primaryApi = fetcher.extend(() => ({ prefixUrl: `${API.PRIMARY}` }));

export const fetchCountries = async ({ signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await primaryApi.get('GetAllCountries', { signal }).json(countriesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on countries response', (error as ValiError<typeof countriesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
